import _ from "lodash";
import React, { useState, useEffect } from "react";
import { Col, Row, Modal, Card, Form } from "react-bootstrap";
import { notificationService } from "service/NotificationService";
import { apiService } from "service/ApiService";
import SaveButton from "components/Buttons/SaveButton";

import { useTranslation } from "react-i18next";

export default function ProductInventoryModal({ product, openModal, parentUpdate }) {
  const {
    t,
  } = useTranslation();

  const [inventory, setInventory] = useState(null);
  const [show, setShow] = useState(false);

  const save = () => {
    if (!inventory) {
      setShow(false);
      return;
    }

    apiService
      .patch(`api/v1/products/${product.id}/inventory`, {
        inventory: inventory,
      })
      .then((resp) => {
        notificationService.notifySuccess(t("messages.stockAddedSuccessfully"));
        // parentUpdate();
        setShow(false);
      })
      .catch((error) => {
        console.error(error);
        setAlert(null);
      });
  };

  useEffect(() => {
    if (openModal === 0) return;
    setShow(true);
    console.log(product);
  }, [openModal]);

  const closeModal = () => setShow(false);

  const handleChange = (e) => {
    setInventory(Number(e.target.value));
  };

  return (
    <>
      <Modal size="lg" dialogClassName="my-modal" show={show} onHide={closeModal} aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Body>
          <Card>
            <Card.Header>
              <Card.Title as="h4">
                {t("common.labels.stockSuffix")}{product?.name} ({product?.inventory})
              </Card.Title>
            </Card.Header>
            <Card.Body>
              <Form action="#" method="#">
                <Row>
                  <Col md="12">
                    <Form.Group>
                      <label>{t("common.actions.addStock")}</label>
                      <Form.Control placeholder={t("common.actions.addStock")} required={true} type="number" onChange={handleChange}></Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Card.Body>
          </Card>
        </Modal.Body>
        <Modal.Footer>
          <Row className="float-left" style={{ width: "100%" }}>
            <Col>
              <SaveButton handler={save} />
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </>
  );
}
